import { Heading } from "@/components/Common/Heading";
import { useIsSuperAdmin } from "@/hooks/useIsSuperAdmin";
import { AppVersionForm } from "@/components/Admin/AppVersionForm";
import { AppInfo } from "@/types/v2";
import { appInfoRepository } from "@/repositories/appInfoRepository";
import { useEffect, useState } from "react";
import { Loading } from "@/components/Page/Loading";

export const AppConfigPage = () => {
  useIsSuperAdmin();
  const [appInfo, setAppInfo] = useState<AppInfo>();
  const [isLoading, setIsLoading] = useState(true);

  const handleAppVersionSubmit = (values: Partial<AppInfo>) => {
    appInfoRepository.update(values as AppInfo);
  };

  useEffect(() => {
    appInfoRepository
      .get()
      .then((res) => setAppInfo(res))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div className="p-5">
      <Heading>App Config</Heading>
      <div className="flex max-w-screen-md flex-col items-center gap-4 rounded-xl border border-primary-foreground p-4">
        {isLoading ? (
          <Loading />
        ) : (
          <AppVersionForm data={appInfo} onSubmit={handleAppVersionSubmit} />
        )}
      </div>
    </div>
  );
};
